const o = {
  color: {
    background: "#f9fafaff",
    border: "#abb9c7ff",
    content: {
      background: "rgba(0, 0, 0, 0.05)"
    }
  }
};
export {
  o as actionSelect
};
